export default class EmployerFactory {
  create() {
    return {
      avatar: '',
      first_name: '',
      last_name: '',
      middle_name: '',
      email: null,
      phone: '',
      // TODO Хардкод за час - все суперпользователи
      is_superuser: false,
      services: [],
      service_categories: [],
      work_position_id: null,
      region_id: null,
      city_id: null,
      category_id: null,
      unit_id: null,
      start_work_at: null,
      birthday_at: null,
      interview_at: null,
      end_work_at: null,
      schedule_type: 0,
      employer_price_category_id: null,
      work_position: {
        permissions: {},
      },
      info: {
        fields: [],
      },
      employer_status_id: null,
      hr_manager_id: null,
      hr_manager: null,
      password: null,
      can_login: true,
      send_password: false,
    }
  }

  createWithCandidate() {
    return {
      first_name: '',
      last_name: '',
      middle_name: '',
      email: null,
      phone: '',
      services: [],
      service_categories: [],
      work_position_id: null,
      region_id: null,
      city_id: null,
      category_id: null,
      status: null,
      unit_id: null,
      start_work_at: null,
      birthday_at: null,
      interview_at: null,
      end_work_at: null,
      schedule_type: 0,
      work_position: {
        permissions: {},
      },
      info: {
        fields: [],
      },
      employer_status_id: 1,
      hr_manager_id: null,
      hr_manager: null,
      password: null,
      can_login: true,
      send_password: false,
      document: {
        number: null,
        issued_at: null,
        employer_document_type_id: null,
      },
    }
  }

  createWithCandidateObj(obj) {
    return {
      first_name: obj.first_name ? obj.first_name : '',
      last_name: obj.last_name ? obj.last_name : '   ',
      middle_name: '',
      email: null,
      phone: obj.mobile_phone ? obj.mobile_phone : '',
      services: [],
      service_categories: [],
      work_position_id: null,
      region_id: null,
      city_id: 1,
      category_id: null,
      status: null,
      unit_id: null,
      start_work_at: null,
      birthday_at: null,
      interview_at: null,
      end_work_at: null,
      schedule_type: 0,
      work_position: {
        permissions: {},
      },
      info: {
        fields: [],
      },
      employer_status_id: 1,
      hr_manager_id: null,
      hr_manager: null,
      password: null,
      can_login: true,
      send_password: false,
      document: {
        number: null,
        issued_at: null,
        employer_document_type_id: null,
      },
    }
  }
}
